var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crud container"},[_vm._v(" shapeUrl : "+_vm._s(_vm.shape_url)+" "),_c('LoadShape')],1)}
var staticRenderFns = []

export { render, staticRenderFns }